import { usePagination } from './utils';
import { PaginationItem } from './components';
import { StyledPagination, StyledList, StyledContainer } from './Pagination.styles';

export interface Props {
  /** current page */
  current: number;
  /** total of pages */
  total: number;
  /** relative URL, example: `/url-slug` */
  urlBase: string;
  localization: {
    next: string;
    prev: string;
    navigation: string;
    goToPage: string;
  };
}

const Pagination = ({ current, total, urlBase, localization }: Props) => {
  const paginationItems = usePagination({ current, total });

  if (!paginationItems.length) {
    return null;
  }

  return (
    <StyledPagination aria-label={localization.navigation}>
      <StyledContainer>
        <StyledList isCenteredOnMobile={paginationItems.length < 5}>
          {paginationItems.map((item) => (
            <PaginationItem
              key={item.id}
              current={current}
              item={item}
              localization={localization}
              urlBase={urlBase}
            />
          ))}
        </StyledList>
      </StyledContainer>
    </StyledPagination>
  );
};

export default Pagination;
